<template>
    <component
        :is="child || 'save-button'"
        :animating="saveProductAnimating"
        :classes="classList"
        :score="score"
        @click.stop="saveProduct(product)"
    />
</template>

<script>
    import SaveButton from '../common/save-button.vue';
    import SaveButtonFooter from '../common/save-button-footer.vue';
    import Mixins from "../../mixins/mixins";
    import {mapGetters} from "vuex";
    import events from "../../store/utils/events.js";
    import { eventNames } from '../../store/utils/tracking';
    
    export default {
        mixins: [Mixins],
        data() {
            return {
                saveProductAnimating: false,
                isLoading: false,
                futureScore: 0, 
            };
        },
        props: ["product", "saveProductClassList", "outfitId", "child", "animation"],
        components: { SaveButton, SaveButtonFooter },
        computed: {
            score() {
                const isProductSaved = this.savedProducts?.some(savedProduct => savedProduct.product_id === this.product.product_id);

                return (isProductSaved || (this.savedProductsLoaded && new Number(this.product.user_product_score || 0)) || (this.isLoading && this.futureScore)) + 0;
            },
            classList() {
                return {
                    [this.saveProductClassList]: true,
                    'loading': this.isLoading && !this.saveProductAnimating,
                };
            },
            ...mapGetters({
                savedProducts: 'savedProducts/savedProducts',
                savedProductsLoaded: 'savedProducts/savedProductsLoaded',
            }),
        },
        methods: {
            saveProduct(product) {
                const score = this.score === 0 ? 1 : 0;
                
                this.isLoading = true;

                this.futureScore = score;

                this.$store.dispatch({
                    type: "savedProducts/scoreProduct",
                    product,
                    score,
                    outfitId: this.outfitId,
                })
                .finally(() => {
                    this.isLoading = false;
                    this.$set(this.product, 'user_product_score', score);
                    
                    if(product?.product_id === this.product?.product_id) {
                        this.saveProductAnimating = true;
                
                        setTimeout(() => {
                            this.saveProductAnimating = false;
                        }, 800);
                    }
                });

                this.$helpers.trackEvent(eventNames.SAVE_PRODUCT, {content_id: product.product_id, price: product.product_price});
            }
        },
        watch: {
            product(newProduct, oldProduct) {
                if(newProduct?.product_id !== oldProduct?.product_id) {
                    this.isLoading = false;
                }
            },
        }
    };
</script>
